export class CommonApi {
    constructor(client) {
        this.client = client;
    }

    // retrieve list of all possible roles for a contact
    async listRoles(){
        const roles = await this.client.get('/api/contacts/roles', {
            anonymous: true
        });

        var result = {
            roles: roles
        }

        return result;
    }

    async sendFeedback(data){
        await this.client.post('/api/Feedback', data);
    }
}